export const DASHED_DATE_FORMAT = 'YYYY-MM-DD'

export const SPACED_DATE_FORMAT = 'YYYY MM DD'

export const STANDARD_DATETIME_FORMAT = 'YYYY-MM-DD, hh:mm'
export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD'
